import React from 'react';
import { Plus, Eye, Edit, Trash2, Search } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Link } from 'react-router-dom';
export function ManageCoupons() {
  const coupons = [{
    id: 1,
    code: 'SUMMER23',
    type: 'Percentage',
    usage: 'General Use',
    amount: '20%',
    expire: '2023-12-31',
    limitations: 'All Courses',
    exceed: 'No'
  }, {
    id: 2,
    code: 'WELCOME',
    type: 'Dollar Amount',
    usage: 'Per Customer',
    amount: '$10.00',
    expire: 'Never',
    limitations: 'Specific Package',
    exceed: 'Yes'
  }];
  return <div className="space-y-6" data-id="element-381">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-382">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-383">Manage Coupons</h1>
        <div className="flex gap-2" data-id="element-384">
          <Link to="/coupons/add" data-id="element-385">
            <Button className="gap-2" data-id="element-386">
              <Plus className="h-4 w-4" data-id="element-387" />
              Add
            </Button>
          </Link>
          <Button variant="secondary" className="gap-2" data-id="element-388">
            <Plus className="h-4 w-4" data-id="element-389" />
            Add PAR Coupon
          </Button>
        </div>
      </div>

      <Card className="p-4" data-id="element-390">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 items-end" data-id="element-391">
          <Input label="Code" placeholder="Coupon code..." data-id="element-392" />
          <Select label="Discount Type" options={[{
          value: '',
          label: 'All Types'
        }, {
          value: 'percent',
          label: 'Percentage'
        }, {
          value: 'dollar',
          label: 'Dollar Amount'
        }]} data-id="element-393" />
          <Select label="Usage Type" options={[{
          value: '',
          label: 'All Usages'
        }, {
          value: 'general',
          label: 'General Use'
        }, {
          value: 'customer',
          label: 'Per Customer'
        }]} data-id="element-394" />
          <Select label="Limitations" options={[{
          value: '',
          label: 'All Limitations'
        }, {
          value: 'all',
          label: 'All Courses/Packages'
        }]} data-id="element-395" />
          <Select label="Exceed Amount" options={[{
          value: '',
          label: 'Any'
        }, {
          value: 'yes',
          label: 'Yes'
        }, {
          value: 'no',
          label: 'No'
        }]} data-id="element-396" />
          <Select label="Group" options={[{
          value: '',
          label: 'All Groups'
        }, {
          value: 'par',
          label: 'PAR'
        }, {
          value: 'saar',
          label: 'SAAR'
        }]} data-id="element-397" />
          <div className="md:col-span-2 lg:col-span-2" data-id="element-398">
            <Button variant="secondary" className="gap-2 w-full" data-id="element-399">
              <Search className="h-4 w-4" data-id="element-400" />
              Search
            </Button>
          </div>
        </div>
      </Card>

      <Card className="overflow-hidden" data-id="element-401">
        <div className="overflow-x-auto" data-id="element-402">
          <table className="w-full text-sm text-left" data-id="element-403">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-404">
              <tr data-id="element-405">
                <th className="px-4 py-3" data-id="element-406">Coupon Code</th>
                <th className="px-4 py-3" data-id="element-407">Discount Type</th>
                <th className="px-4 py-3" data-id="element-408">Usage Type</th>
                <th className="px-4 py-3" data-id="element-409">Discount Amount</th>
                <th className="px-4 py-3" data-id="element-410">Expire Date</th>
                <th className="px-4 py-3" data-id="element-411">Limitations</th>
                <th className="px-4 py-3" data-id="element-412">Exceed Amount</th>
                <th className="px-4 py-3" data-id="element-413">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-414">
              {coupons.map(coupon => <tr key={coupon.id} className="hover:bg-slate-50" data-id="element-415">
                  <td className="px-4 py-3 font-mono font-medium" data-id="element-416">
                    {coupon.code}
                  </td>
                  <td className="px-4 py-3" data-id="element-417">{coupon.type}</td>
                  <td className="px-4 py-3" data-id="element-418">{coupon.usage}</td>
                  <td className="px-4 py-3 font-semibold text-green-600" data-id="element-419">
                    {coupon.amount}
                  </td>
                  <td className="px-4 py-3 text-slate-500" data-id="element-420">{coupon.expire}</td>
                  <td className="px-4 py-3 text-slate-600" data-id="element-421">
                    {coupon.limitations}
                  </td>
                  <td className="px-4 py-3" data-id="element-422">{coupon.exceed}</td>
                  <td className="px-4 py-3" data-id="element-423">
                    <div className="flex items-center gap-2" data-id="element-424">
                      <Button variant="ghost" size="icon" title="View" data-id="element-425">
                        <Eye className="h-4 w-4 text-slate-500" data-id="element-426" />
                      </Button>
                      <Link to={`/coupons/edit/${coupon.id}`} data-id="element-427">
                        <Button variant="ghost" size="icon" title="Edit" data-id="element-428">
                          <Edit className="h-4 w-4 text-blue-600" data-id="element-429" />
                        </Button>
                      </Link>
                      <Button variant="ghost" size="icon" title="Delete" data-id="element-430">
                        <Trash2 className="h-4 w-4 text-red-600" data-id="element-431" />
                      </Button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}